import { v4 } from 'uuid';
import type { SerializedWorkflowNode, WorkflowNodeType } from '../types';
import { JsonValue } from '../../serializable';

export type WorkflowNodeConnectOptions = {
  readonly id?: string;
  /** Resolves this node's step input from another node's output; does not create an edge. */
  readonly inputFrom?: WorkflowGraphNode;
};

export abstract class WorkflowGraphNode {
  readonly id: string;
  private readonly inputFrom?: WorkflowGraphNode;

  protected constructor(options?: WorkflowNodeConnectOptions) {
    this.id = options?.id ?? v4();
    this.inputFrom = options?.inputFrom;
  }

  abstract readonly nodeType: WorkflowNodeType;

  collectNodes(): readonly WorkflowGraphNode[] {
    return [this];
  }

  getInputFromNodeId(): string | undefined {
    return this.inputFrom?.id;
  }

  abstract toSerializedNode(params: {
    workflowId: string;
    ownerId: string;
    ownerOrgId: string;
    createdAt: string;
    updatedAt: string;
  }): SerializedWorkflowNode;

  protected baseSerializedNode(params: {
    workflowId: string;
    ownerId: string;
    ownerOrgId: string;
    createdAt: string;
    updatedAt: string;
    data: JsonValue;
    inputShape: string | null;
    defaultOutput: JsonValue | null;
  }): SerializedWorkflowNode {
    const inputFromNodeId = this.getInputFromNodeId();
    return {
      id: this.id,
      ownerId: params.ownerId,
      ownerOrgId: params.ownerOrgId,
      workflowId: params.workflowId,
      type: this.nodeType,
      data: params.data,
      inputShape: params.inputShape,
      defaultOutput: params.defaultOutput,
      inputFromNodeId: inputFromNodeId ?? null,
      createdAt: params.createdAt,
      updatedAt: params.updatedAt,
    };
  }
}
